import { useState, useEffect } from "react";

import { apiRoot } from "../constants";
import { useAuth } from "./useAuth";

const useDishes = overrideCityId => {
  const [dishes, setDishes] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { cityId } = useAuth();

  useEffect(() => {
    setLoading(true);
    
    let url = "/dishes";
    if (cityId) {
      url = `${url}?city_id=${cityId}`;
    } else if (overrideCityId) {
      url = `${url}?city_id=${overrideCityId}`;
    }
    fetch(`${apiRoot}${url}`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setDishes(json);
            setError(false);
            setLoading(false);
          });
        } else {
          setError(true);
          setDishes([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(true);
        setDishes([]);
        setLoading(false);
      });
  }, [cityId, overrideCityId]);

  return {
    dishes,
    error,
    loading,
  };
};

export default useDishes;
